'use strict';

var objectWithoutProperties = require('../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var withStyles = require('../../../Styles/withStyles.js');
var Tooltip = require('../../../DataDisplay/Tooltips/Tooltip.js');
var IconButton = require('../../../Inputs/Buttons/IconButton.js');
var HelpOutline = require('../../../../IconsAndImages/Icons/HelpOutline.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles(theme) {
  return {};
};

var HelpIcon = function HelpIcon(_ref) {
  _ref.classes;
      objectWithoutProperties(_ref, ["classes"]);

  return React__default["default"].createElement(Tooltip, {
    title: "Help"
  }, React__default["default"].createElement(IconButton, {
    onClick: ''
  }, React__default["default"].createElement(HelpOutline, null)));
};

var HelpIcon$1 = withStyles["default"](styles)(HelpIcon);

module.exports = HelpIcon$1;
